export class CategoryIdRequest {
    categoryId:number;
    constructor(categoryId:number) {
        this.categoryId=categoryId;
    }
}